import React, { Component } from "react"
import { translate } from "react-translate"
import SegmentGroup, { Button, Icon } from "semantic-ui-react"
import "./ButtonModif.css"

class ButtonModif extends Component {
  constructor(props) {
    super(props)
  }
  render() {
    let { t } = this.props

    return (
      <Button id="modifButton">
        <Icon
          className="pencil alternate"
          icons="pencil alternate"
          name="pencil alternate"
        />
        <label>{t("button_modif")}</label>
      </Button>
    )
  }
}

export default translate("ProButtonModif")(ButtonModif)



// WEBPACK FOOTER //
// ./src/components/Pro/DevisFactures/EditionDevisFactures/ButtonModif.js